import { useGetV2Networks } from "@/gen/orval/webplatform/endpoints/networks/networks.gen";

export function useGetAllNetworks() {
  const networksRaw = useGetV2Networks();

  return {
    networks: {
      ...networksRaw,
      data: networksRaw?.data?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")),
    },
  };
}
